import { useOrganizationContext } from "../../../contexts/organizations/organizationsContext";
import { Navbar } from "./Navbar";

export function HeaderWrapper() {
  const { accessAllowed } = useOrganizationContext();

  return (
    <div
      data-testid="kt_app_header"
      className="bg-white position-fixed w-100 header-z-index"
      style={accessAllowed ? {} : { top: 56 }}
    >
      <div className="app-header">
        <div className="app-container flex-lg-grow-1 align-items-center justify-content-end">
          <div id="burger-container" className="position-absolute " />
          <div className="d-flex align-items-stretch justify-content-end flex-lg-grow-1 h-100">
            <Navbar />
          </div>
        </div>
      </div>
    </div>
  );
}
